/**
 * True for touch-primary devices (tablets, phones, Tizen TV shells).
 * Used to hide mouse-oriented chrome like zoom +/- buttons.
 */
export default function isTouchDevice() {
  if (typeof document !== 'undefined'
    && document.documentElement?.dataset?.platform === 'tizen') {
    return true;
  }
  if (typeof window !== 'undefined' && typeof window.matchMedia === 'function') {
    try {
      if (window.matchMedia('(hover: none)').matches) return true;
    } catch {
      // ignore
    }
  }
  return false;
}
